import {Breadcrumb, Col, Divider, Row, Tag} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'
import {StarFilled, StarOutlined} from "@ant-design/icons";

function Partners() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/partner/?populate[PartnersList][populate]=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (<>
            <Row gutter={24} className={"Content"}>
                <Col span={12}>
                    <h1>{content.PageTitle}</h1>
                </Col>
                <Col span={12} style={{textAlign: "right"}}>
                    <Breadcrumb
                        style={{float: "right"}}
                        items={[
                            {
                                href: '/',
                                title: (
                                    <>
                                        <span>Home</span>
                                    </>
                                ),
                            },
                            {
                                title: 'Partners',
                            },
                        ]}
                    />
                </Col>
            </Row>

            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingTop: 0}}>
                <Col span={24}>
                    <h2>{content.SubTitle}</h2>
                    <Divider className={"TransitionColors"} orientation="left">{content.Quote}</Divider>
                </Col>
            </Row>

            <Row gutter={24} className={"Content"} style={{textAlign: "center", paddingBottom: 120}}>
                {(content?.PartnersList ?? []).map((value, key) => {
                    return <Col style={{padding: "24px 48px", margin: "auto"}}>
                        <img style={{maxHeight: 16, display: "block", float: "right", margin: "0 0 16px 0"}}
                             src={process.env.REACT_APP_STRAPI_URL + value.CountryFlag.data.attributes.url}
                        />
                        <a href={value.Link}
                           target={"_blank"}
                           style={{display: "block", marginBottom: 16}}
                        >
                            <img
                                style={{maxWidth: 160}}
                                 src={process.env.REACT_APP_STRAPI_URL + value.Logo.data.attributes.url}
                                 alt=""/>
                        </a>
                        <h5 style={{textTransform: "uppercase", fontWeight: "300"}}>
                            {value.Title}
                        </h5>
                    </Col>

                })}
            </Row>
        </>
    )
}

export default Partners